export const IBookContentRepository = {
    fetchBooks: async ({ token }) => { throw new Error('fetchBooks is not implemented'); },
    getPurchasedProducts: async ({ token }) => { throw new Error('getPurchasedProducts is not implemented'); },
    getBookContent: async ({ book, pages = [] }) => { throw new Error('getBookContent is not implemented'); },
    getInteractiveObjects: async ({ interactiveObjectId, pages }) => { throw new Error('getInteractiveObjects is not implemented'); },
    getThumbnailUrls: ({ bookId, pages }) => { throw new Error('getThumbnailUrls is not implemented'); },
    getBookCatalog: async ({ bookId }) => { throw new Error('getBookCatalog is not implemented'); },
    getIsShowInteractiveObject: ({ role, interactiveObject }) => { throw new Error('getIsShowInteractiveObject is not implemented'); },
};
